// migration version is also used in InitialLoader
// https://github.com/wix-private/santa-editor/blob/master/santa-editor/packages/main/startup/initialLoader/utils/canShowHeavySitesMigrationLoader.ts
export const MIGRATION_VERSION = '0.0.9';
